import { Link } from "@inertiajs/react";
import AdminLayout from "./layout";

type Props = {
  page_list: {
    id: string;
  }[];
};

export default function UITestIndex({ page_list }: Props) {
  return (
    <AdminLayout pageName="testing">
      <div className="p-6">
        <h1 className="text-2xl font-bold">UI Testing pages</h1>
        <ul className="mt-4 space-y-2">
          {page_list.map((page) => (
            <li key={page.id}>
              <Link className="hover:underline" href={`/admin/uitest/${page.id}`}>
                {page.id}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </AdminLayout>
  );
}
